export function channelsOf(image) { return image.channels ?? 4; }
export function strideOf(image) { return image.stride ?? image.width * channelsOf(image); }
export function assertImage(image) {
    if (!Number.isInteger(image.width) || image.width <= 0)
        throw new Error(`Invalid image width: ${image.width}`);
    if (!Number.isInteger(image.height) || image.height <= 0)
        throw new Error(`Invalid image height: ${image.height}`);
    const channels = channelsOf(image);
    if (channels !== 3 && channels !== 4)
        throw new Error(`Unsupported channel count: ${channels}`);
    const stride = strideOf(image);
    if (stride < image.width * channels)
        throw new Error(`Invalid stride ${stride}`);
    const minBytes = stride * (image.height - 1) + image.width * channels;
    if (image.data.length < minBytes)
        throw new Error(`Image data is too small: got ${image.data.length}, need ${minBytes}`);
}
export function assertRectInside(image, rect) {
    if (!Number.isInteger(rect.x) || !Number.isInteger(rect.y) || !Number.isInteger(rect.width) || !Number.isInteger(rect.height)
        || rect.width < 0 || rect.height < 0 || rect.x < 0 || rect.y < 0
        || rect.x + rect.width > image.width || rect.y + rect.height > image.height) {
        throw new Error(`Rectangle ${JSON.stringify(rect)} is outside ${image.width}x${image.height}`);
    }
}
export function getRgb(image, x, y) {
    const channels = channelsOf(image);
    const i = y * strideOf(image) + x * channels;
    return [image.data[i] ?? 0, image.data[i + 1] ?? 0, image.data[i + 2] ?? 0];
}
export function setRgb(image, x, y, rgb) {
    const channels = channelsOf(image);
    const i = y * strideOf(image) + x * channels;
    image.data[i] = rgb[0];
    image.data[i + 1] = rgb[1];
    image.data[i + 2] = rgb[2];
    if (channels === 4)
        image.data[i + 3] = 255;
}
export function cloneImage(source) {
    assertImage(source);
    const data = new Uint8ClampedArray(source.data.length);
    data.set(source.data);
    return { width: source.width, height: source.height, data, channels: channelsOf(source), stride: strideOf(source) };
}
export function cropImage(source, rect) {
    assertImage(source);
    assertRectInside(source, rect);
    const channels = channelsOf(source);
    const targetStride = rect.width * channels;
    const out = new Uint8ClampedArray(targetStride * rect.height);
    const sourceStride = strideOf(source);
    for (let y = 0; y < rect.height; y++) {
        const start = (rect.y + y) * sourceStride + rect.x * channels;
        out.set(source.data.subarray(start, start + targetStride), y * targetStride);
    }
    return { width: rect.width, height: rect.height, data: out, channels, stride: targetStride };
}
export function copyImageInto(source, target, dx, dy) {
    assertImage(source);
    assertImage(target);
    if (channelsOf(source) !== channelsOf(target))
        throw new Error('source and target channels differ');
    assertRectInside(target, { x: dx, y: dy, width: source.width, height: source.height });
    const channels = channelsOf(source);
    for (let y = 0; y < source.height; y++) {
        for (let x = 0; x < source.width; x++)
            setRgb(target, dx + x, dy + y, getRgb(source, x, y));
    }
}
export function rectFromLTRB(left, top, right, bottom) {
    return { x: left, y: top, width: right - left, height: bottom - top };
}
export function relativeTo(base, rect) { return { x: base.x + rect.x, y: base.y + rect.y, width: rect.width, height: rect.height }; }
export function localTo(base, rect) { return { x: rect.x - base.x, y: rect.y - base.y, width: rect.width, height: rect.height }; }
//# sourceMappingURL=image.js.map